module.exports = "static/assets/912e19a8fe314f46ab3df3fed9578a29.mp3";